import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-returns',
  templateUrl: './icon-returns.component.html',
  styleUrls: []
})
export class IconReturnsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
